import { useNavigate } from 'react-router';
import { useTranslation } from 'react-i18next';
import { ChevronRight } from 'lucide-react';
import { useSubscriptionInvoices } from '../../../hooks/useSubscription';

function fmtVnd(n: number) {
  return new Intl.NumberFormat('vi-VN').format(n) + 'đ';
}
function fmtDate(iso: string) {
  return new Date(iso).toLocaleDateString('vi-VN');
}

export function InvoicesTab() {
  const { t } = useTranslation('billing');
  const navigate = useNavigate();
  const { data, isLoading, error } = useSubscriptionInvoices();
  if (isLoading) return <div className="p-6 text-surface-500">…</div>;
  if (error) {
    return (
      <div className="p-6 text-red-700 bg-red-50 border border-red-200 rounded-md max-w-2xl">
        {(error as Error).message}
      </div>
    );
  }
  if (!data || data.length === 0) {
    return <div className="p-6 text-surface-500">{t('invoicesEmpty')}</div>;
  }
  return (
    <div className="p-6 overflow-x-auto">
      <table className="w-full text-[13px]">
        <thead>
          <tr className="text-left text-surface-500 border-b border-surface-200">
            <th className="py-2 pr-3">{t('columns.period')}</th>
            <th className="py-2 pr-3">{t('columns.amount')}</th>
            <th className="py-2 pr-3">{t('columns.status')}</th>
            <th className="py-2 pr-3">{t('columns.paidAt')}</th>
            <th className="py-2 w-6"></th>
          </tr>
        </thead>
        <tbody>
          {data.map((inv) => (
            <tr
              key={inv.id}
              onClick={() => navigate(`/billing/invoices/${inv.id}`)}
              className="border-b border-surface-100 hover:bg-surface-50 cursor-pointer"
            >
              <td className="py-2 pr-3 text-brand-700 font-medium">
                {fmtDate(inv.periodStart)} → {fmtDate(inv.periodEnd)}
              </td>
              <td className="py-2 pr-3">{fmtVnd(inv.amountVnd)}</td>
              <td className="py-2 pr-3">{inv.status}</td>
              <td className="py-2 pr-3">{inv.paidAt ? fmtDate(inv.paidAt) : '—'}</td>
              <td className="py-2 text-surface-400">
                <ChevronRight className="w-4 h-4" />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
